export default "__VITE_ASSET__CItzUwXB__"